import '#/platform/markBundleStartTime'
import '#/platform/polyfills'

import {registerRootComponent} from 'expo'

import App from '#/App'

// The Jitsi external_api.js script is loaded lazily by JitsiMeeting/JitsiGuestMeeting
// once we know which backend (JaaS vs self-hosted VPS) the worker has chosen.

registerRootComponent(App)
